import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AppleAuthForm from "../../components/Forms/AppleAuthForm";
import FacebookAuthForm from "../../components/Forms/FaceBookAuthForm";
import GoogleAuthForm from "../../components/Forms/GoogleAuthForm";
import InstagramAuthForm from "../../components/Forms/InstagramAuthForm";
import { AuthContext } from "../../context/AuthContext";
import {
  FacebookIcon2,
  GoogleIcon,
  InstagramIcon2,
  AppleIcon,
} from "../../icons";
import "./signup.css";
import TextField from "@mui/material/TextField";

export default function FormActions({ onClick, isRecruiter }) {
  const history = useHistory();
  const { setIsSignUpPopup, setIsSignInPopup } = useContext(AuthContext);
  const [emailError, setEmailError] = useState(false);
  const [accountStatus, setAccountStatus] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [referral, setReferral] = useState("");
  const [error, setError] = useState('');

  const navigatetoContact = () => {
    setIsSignUpPopup(false);
    setIsSignInPopup(false);
    history.push("/about/contact-us");
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get("ref");
    if (refCode) {
      setReferral(refCode.toUpperCase());
    }
  }, []);

  const handleReferralChange = (e) => {
    const value = e.target.value;
    setReferral(value);

    // Add validation logic here
    if (value.length < 4) {
      setError('Referral code must be at least 4 characters');
    } else {
      setError('');
    }
  };
  return (
    <div className="form_action_container">
      {emailError === true ? (
        <div className="errMsgcontainer p-4 mb-3">
          {" "}
          <p className="emailErrText " style={{ marginBottom: 25 }}>
            Oops! We need an email!{" "}
          </p>
          <p className="fontStyl" style={{ marginBottom: 25 }}>
            Sorry, we could not find the email address linked to your Sign-up
            choice.{" "}
          </p>
          <p className="fontStyl">
            Please <b>use another Sign-up</b> option.
          </p>
        </div>
      ) : null}
      {accountStatus === "Deleted" ? (
        <div className="errMsgcontainer p-4 mb-3">
          {" "}
          <p className="emailErrText " style={{ marginBottom: 10 }}>
            Profile Deleted
          </p>
          <p className="fontStyl">
            Sorry, this profile no longer exists. Please{" "}
            <span onClick={navigatetoContact} className="linkText">
              contact
            </span>{" "}
            the admin for more information.
          </p>
        </div>
      ) : accountStatus === "Banned" ? (
        <div className="errMsgcontainer p-4 mb-3">
          {" "}
          <p className="emailErrText " style={{ marginBottom: 10 }}>
            Profile Banned
          </p>
          <p className="fontStyl">
            Sorry, your profile is banned and you won’t be able to login or
            create another profile using the same credentials. Please{" "}
            <span onClick={navigatetoContact} className="linkText">
              contact
            </span>{" "}
            the admin for more information.{" "}
          </p>
        </div>
      ) : accountStatus === "Locked" ? (
        <div className="errMsgcontainer p-4 mb-3">
          {" "}
          <p className="emailErrText " style={{ marginBottom: 10 }}>
            Profile Locked
          </p>
          <p className="fontStyl">
            Sorry, your profile is locked and you will not be able login. Please{" "}
            <span onClick={navigatetoContact} className="linkText">
              contact
            </span>{" "}
            the admin for more information.{" "}
          </p>
        </div>
      ) : accountStatus === "Freeze" ? (
        <div className="errMsgcontainer p-4 mb-3">
          {" "}
          <p className="emailErrText " style={{ marginBottom: 10 }}>
            Profile Freeze
          </p>
          <p className="fontStyl">
            Sorry, your profile is under freeze and you will not be able to
            apply to new jobs or make any changes to the profile. Please{" "}
            <span onClick={navigatetoContact} className="linkText">
              contact
            </span>{" "}
            the admin for more information.
          </p>
        </div>
      ) : (
        accountStatus?.length > 6 && (
          <div className="errMsgcontainer p-4 mb-3">
            <p className="emailErrText " style={{ marginBottom: 10 }}>
              Error{" "}
            </p>
            <p className="fontStyl">{accountStatus}</p>
          </div>
        )
      )}
      {accountStatus === "error" && (
        <div className="errMsgcontainer p-4 mb-3">
          {" "}
          <p className="emailErrText " style={{ marginBottom: 10 }}>
            Something went wrong
          </p>
          <p className="fontStyl">{errorMsg}</p>
        </div>
      )}
      <TextField
        className="refereral_codes"
        id="outlined-multiline-flexible"
        placeholder="Enter your REFERRAL CODE, if available"
        onChange={handleReferralChange}
        value={referral}
        multiline
        maxRows={4}
        error={Boolean(error)}
        helperText={error}
      />
      <GoogleAuthForm
        closemodel={() => setIsSignUpPopup(false)}
        name="Sign up with Google"
        setAccountStatus={setAccountStatus}
        isRecruiter={isRecruiter}
        referral={referral}
        setReferral={setReferral}
      />
      {/* <FacebookAuthForm
        setEmailError={setEmailError}
        closemodel={() => setIsSignUpPopup(false)}
        name="Sign up with Facebook"
        setErrorMsg={setErrorMsg}
        setAccountStatus={setAccountStatus}
        isRecruiter={isRecruiter}
        referral={referral}

      /> */}
      {/* <InstagramAuthForm closemodel={() => setIsSignUpPopup(false)} name='Sign up with Instagram' /> */}
      {/* <AppleAuthForm closemodel={() => setIsSignUpPopup(false)} name='Sign up with Apple' /> */}

      <p className="terms_info mt-2">
        By signing up, you accept the{" "}
        <button
          onClick={() => {
            history.push("/view-cms/terms-and-condition");
            setIsSignUpPopup(false);
            setIsSignInPopup(false);
          }}
          className="link"
        >
          <b>Terms of Use</b>
        </button>
      </p>
      <h6 className="footer_text text-center mt-10">
        Already have an account?{" "}
        <span
          className="link"
          onClick={() => {
            setIsSignUpPopup(false);
            setIsSignInPopup(true);
          }}
        >
          <b>Sign in</b>
        </span>
      </h6>
    </div>
  );
}
